import React from 'react';
import ClassNames from 'classnames';
import moment from 'moment';
import DateTime from 'utils/date-time';
import Transition from 'components/transition-groups/Transition';
import Container from 'components/flexbox/Container';
import Block from 'components/flexbox/Block';
import EnhancedButton from 'components/buttons/enhanced-button/EnhancedButton';



export default React.createClass({

	propTypes: {
		selectedDate: React.PropTypes.object.isRequired,
		onHourUp: React.PropTypes.func,
		onHourDown: React.PropTypes.func,
		onMinuteUp: React.PropTypes.func,
		onMinuteDown: React.PropTypes.func,
		onSecondUp: React.PropTypes.func,
		onSecondDown: React.PropTypes.func,
		onMeridiemUp: React.PropTypes.func,
		onMeridiemDown: React.PropTypes.func,
		onTimezoneRight: React.PropTypes.func,
		onTimezoneLeft: React.PropTypes.func,
		transitionDirection: React.PropTypes.string,
		timeDisplayOpen: React.PropTypes.bool,
		maxDate: React.PropTypes.object,
		minDate: React.PropTypes.object,

	},

	getInitialState() {
		return {
			transitionDirection: this.props.transitionDirection,
			timeDisplayOpen: this.props.timeDisplayOpen,
		};
	},

	getDefaultProps() {
		return {
			timeDisplayOpen: true,
		}
	},

	componentWillReceiveProps(nextProps) {

	},

	render() {
		let { selectedDate } = this.props;

		let hour = selectedDate.format('hh'),
			minute = selectedDate.format('mm'),
			second = selectedDate.format('ss'),
			meridiem = selectedDate.format('a'),
			timezone = selectedDate._z.name,
			disabledHourUp = this._isDisabled('hour','up', 1 ),
			disabledHourDown = this._isDisabled('hour','down', 1),
			disabledMinuteUp = this._isDisabled('minute','up', 1),
			disabledMinuteDown = this._isDisabled('minute','down', 1),
			disabledSecondUp = this._isDisabled('second','up', 1),
			disabledSecondDown = this._isDisabled('second','down', 1),
			disabledMeridiemUp = this._isDisabled('hour','up', 12),
			disabledMeridiemDown = this._isDisabled('hour','down', 12);

		let classes = ClassNames(this.props.className , 'lui-date-picker-time-display', {
			'lui-is-visible' : this.state.timeDisplayOpen
		});

		return (
			<div>
				<div {...this.props} className={classes}>
					<div className="lui-date-picker-time-display-container">
						
						<Container className="lui-date-picker-time-display-wrapper" flexDirection="row" >
							<Block>
								<Container flexDirection="column">
									<Block>
										<EnhancedButton
											disableFocusRipple={true}
											disableTouchRipple={true}
											className="lui-date-picker-time-display-selection-icon"
											onClick={this._handleHourUp}
											disabled={disabledHourUp}>
											<i className="fa fa-caret-up" />
										</EnhancedButton>
									</Block>
									<Block>	
										<Transition
											className="lui-date-picker-time-display-time"
											direction={this.props.transitionDirection}
											type="slide-in">
											<div key={hour}>{hour}</div>
										</Transition>
									</Block>
									<Block>
										<EnhancedButton
											disableFocusRipple={true}
											disableTouchRipple={true}
											className="lui-date-picker-time-display-selection-icon"
											onClick={this._handleHourDown}
											disabled={disabledHourDown}>
											<i className="fa fa-caret-down" />
										</EnhancedButton>
									</Block>
								</Container>
							</Block>
							<Block width={0.1}>                     
								<div className="lui-date-picker-time-display-time-separator">:</div>
							</Block>
							<Block>                     
								<Container flexDirection="column">
									<Block>
										<EnhancedButton
											disableFocusRipple={true}
											disableTouchRipple={true}
											className="lui-date-picker-time-display-selection-icon"
											onClick={this._handleMinuteUp}
											disabled={disabledMinuteUp}>
											<i className="fa fa-caret-up" />
										</EnhancedButton>
									</Block>
									<Block>	
										<Transition
											className="lui-date-picker-time-display-time"
											direction={this.props.transitionDirection}>
											<div key={minute}>{minute}</div>
										</Transition>
									</Block>
									<Block>
										<EnhancedButton
											disableFocusRipple={true}
											disableTouchRipple={true}
											className="lui-date-picker-time-display-selection-icon"
											onClick={this._handleMinuteDown}
											disabled={disabledMinuteDown}>
											<i className="fa fa-caret-down" />
										</EnhancedButton>
									</Block>
								</Container>
							</Block>                            
							<Block width={0.1}>                     
								<div className="lui-date-picker-time-display-time-separator">:</div>
							</Block>
							<Block>
								<Container flexDirection="column">
									<Block>
										<EnhancedButton
											disableFocusRipple={true}
											disableTouchRipple={true}
											className="lui-date-picker-time-display-selection-icon"
											onClick={this._handleSecondUp}
											disabled={disabledSecondUp}>
											<i className="fa fa-caret-up" />
										</EnhancedButton>
									</Block>
									<Block>	
										<Transition
											className="lui-date-picker-time-display-time"
											direction={this.props.transitionDirection}>
											<div key={second}>{second}</div>
										</Transition>
									</Block>
									<Block>
										<EnhancedButton
											disableFocusRipple={true}
											disableTouchRipple={true}
											className="lui-date-picker-time-display-selection-icon"
											onClick={this._handleSecondDown}
											disabled={disabledSecondDown}>
											<i className="fa fa-caret-down" />
										</EnhancedButton>
									</Block>
								</Container>
							</Block>							
							<Block>                     
								<Container flexDirection="column">
									<Block>
										<EnhancedButton
											disableFocusRipple={true}
											disableTouchRipple={true}
											className="lui-date-picker-time-display-selection-icon"
											onClick={this._handleMeridiemUp}
											disabled={disabledMeridiemUp}>
											<i className="fa fa-caret-up" />
										</EnhancedButton>
									</Block>
									<Block>	
										<Transition
											className="lui-date-picker-time-display-time"
											direction={this.props.transitionDirection}>
											<div key={meridiem}>{meridiem}</div>
										</Transition>
									</Block>
									<Block>
										<EnhancedButton
											disableFocusRipple={true}
											disableTouchRipple={true}
											className="lui-date-picker-time-display-selection-icon"
											onClick={this._handleMeridiemDown}
											disabled={disabledMeridiemDown}>
											<i className="fa fa-caret-down" />
										</EnhancedButton>
									</Block>
								</Container>
							</Block>
						</Container>

								<Container flexDirection="row">
									<Block width={0.1}>
										<i 
											className="lui-date-picker-time-display-selection-icon fa fa-caret-left" 
											onClick={this._handleTimezoneLeft} />
									</Block>
									<Block width={0.8}>	
										<Transition
											className="lui-date-picker-time-display-timezone"
											direction="left">
											<div key={timezone}>{timezone}</div>
										</Transition>
									</Block>
									<Block width={0.1}>
										<i 
											className="lui-date-picker-time-display-selection-icon fa fa-caret-right" 
											onClick={this._handleTimezoneRight} />
									</Block>
						</Container>

					</div>

				</div>
			</div>
		);
	},

	toggle() {
		this.setState({
			timeDisplayOpen: !this.state.timeDisplayOpen
		});
	},
	
	_isDisabled: function(time, direction, amount){
	
		let date = this.props.selectedDate,
			minDate = this.props.minDate,
			maxDate = this.props.maxDate,
			timeUp = moment(date).add(amount, time),
			timeDown = moment(date).subtract(amount, time);


		if (direction == 'up' && maxDate) {
			if (timeUp > maxDate) {
				return true;
			} 
		} else if (direction == 'down' && minDate) {
			if (timeDown < minDate) {
				return true;
			}
		}

		return false;
	},	

	_handleHourUp() {
		this.props.onHourUp();
	},	

	_handleHourDown() {
		this.props.onHourDown();
	},

	_handleMinuteUp() {
		this.props.onMinuteUp();
	},

	_handleMinuteDown() {
		this.props.onMinuteDown();
	},

	_handleSecondUp() {
		this.props.onSecondUp();
	},

	_handleSecondDown() {
		this.props.onSecondDown();
	},
	
	_handleMeridiemUp() {
		this.props.onMeridiemUp();
	},
	
	_handleMeridiemDown() {
		this.props.onMeridiemDown();
	},

	_handleTimezoneRight() {
		this.props.onTimezoneRight()
	},

	_handleTimezoneLeft() {
		this.props.onTimezoneLeft()
	},


});


/** WEBPACK FOOTER **
 ** ./src/components/date-picker/TimeDisplay.js
 **/